import api from '@/plugins/api'
import { accountVL, moderationQuestionVL } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
import { formData } from '@/configs/dates'
import notify from '@ananasbear/notify'
const store = 'accountVL'

export default {
  state: () => ({
    measuringLaboratory: null,
    errorMeasuringLaboratory: false,
    measuringLaboratoryList: [],
    contractList: [],
    contractItem: null,
    branchVL: null,
    branchesList: [],

    moderationQuestionVL: [],
    moderationFileQuestionVL: [],
    moderationDirectorFileQuestionVL: [],

    hasModerationWrongBranch: false,
    moderationBranchQuestionVL: {},
    moderationBranchFileQuestionVL: {}
  }),
  mutations: {
    SET_BRANCH (state, data) {
      state.branchesList.push(data)
    },
    DELETE_BRANCH (state, data) {
      let index = state.branchesList.findIndex(e => e.id === data)
      if (index !== -1) {
        state.branchesList.splice(index, 1)
      }
    },
    SET_BRANCH_QUERY (state, data) {
      state.moderationBranchQuestionVL = Object.assign({}, state.moderationBranchQuestionVL, data)
    },
    SET_BRANCH_FILE_QUESTION (state, data) {
      state.moderationBranchFileQuestionVL = Object.assign({}, state.moderationBranchFileQuestionVL, data)
    }
  },
  getters: {
    reprocessingTypeReviewVL: state => {
      // previous_statement_step: type_review
      let typeReviewByPrevStatus = {
        2: 3,
        3: 1
      }
      if (state.measuringLaboratory) {
        return typeReviewByPrevStatus[state.measuringLaboratory.previous_statement_step]
      }
    },
  },
  actions: {
    async registrationMeasuringLaboratory (context, body) {
      const response = await api.post(accountVL.measuringLaboratory, { body: body })
      if (response.code === 400) context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: true })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data })
        context.commit('ADD_DATA', { store, state: 'measuringLaboratoryList', data: response.data })
        context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: false })
        return response.data
      }
      return false
    },
    async updateMeasuringLaboratory (context, data) {
      const response = await api.patch(accountVL.updateMeasuringLaboratory(data.id), { body: data.body })
      if (response.code === 400) context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: true })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data })
        context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: false })
        return response.data
      }
      return false
    },

    async getMeasuringLaboratory (context) {
      const response = await api.get(accountVL.measuringLaboratoryList)
      if (await requestValidation(response)) {
        if (response.data.results.length) {
          context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data.results.at(-1) })
        }
        return response.data
      }
      return false
    },
    measuringLaboratoryMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.post(accountVL.measuringLaboratoryMedia(data.id), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    measuringLaboratoryUpdateMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.put(accountVL.measuringLaboratoryUpdateMedia(data.id), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async deleteMeasuringLaboratoryMedia (context, data) {
      const response = await api.delete(accountVL.deleteMeasuringLaboratoryMedia(data))
      return !!(await requestValidation(response))

    },

    // Moderation  -------------------------------------------------------
    // async updateModerationMeasuringLaboratory (context, data) {
    //   const response = await api.patch(accountVL.updateModerationMeasuringLaboratory(data.id), { body: data.body })
    //   if (response.code === 400) context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: true })
    //   if (await requestValidation(response)) {
    //     // context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data })
    //     // context.commit('SET_DATA', { store, state: 'errorMeasuringLaboratory', data: false })
    //     return response.data
    //   }
    //   return false
    // },

    // Contract ----------------------------------------------------------

    async getContractWithOC (context, id) {
      const response = await api.get(accountVL.contractWithOC(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'contractList', data: response.data.results })
        return response.data
      }
      return false
    },
    async createContractWithOC (context, data) {
      const response = await api.post(accountVL.contractWithOC(data.id), { body: data.body })
      if (response.code === 404) {
        let error = await response.data.json()
        notify.warning(`notify.requestErrors.${ error.detail.replace(/ /g, '_').replace('.', '') }`)
      } else {
        if (await requestValidation(response)) {
          context.commit('ADD_DATA', { store, state: 'contractList', data: response.data })
          context.commit('SET_DATA', { store, state: 'contractItem', data: response.data })
        }
      }
    },
    async updateContractWithOC (context, data) {
      const response = await api.patch(accountVL.updateContractWithOC(data.ids), { body: data.body })
      if (response.code === 404) {
        let error = await response.data.json()
        notify.warning(`notify.requestErrors.${ error.detail.replace(/ /g, '_').replace('.', '') }`)
      } else {
        if (await requestValidation(response)) {
          context.commit('UPDATE_DATA', { store, state: 'contractList', data: response.data })
          context.commit('SET_DATA', { store, state: 'contractItem', data: response.data })
        }
      }
    },
    contractWithOCMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.post(accountVL.contractWithOCMedia(data.ids), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    contractWithOCUpdateMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.put(accountVL.contractWithOCUpdateMedia(data.ids), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    async deleteContractMedia (context, data) {
      const response = await api.delete(accountVL.deleteContractMedia(data))
      if (await requestValidation(response)) {
        return true
      }
      return false
    },

    // Branch ----------------------------------------------------------
    async createBranchVL (context, data) {
      const response = await api.post(accountVL.branchVL(data.id), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchVL', data: response.data })
        let city = await context.dispatch('getDirectoryById', { endpoint: 'city', id: response.data.address.city })
        let region = await context.getters.directoryById('region', city.region)?.name
        response.data.address.city = city.name
        response.data.address.region = region
        context.commit('SET_BRANCH', response.data)
        return response.data
      }
      return false
    },
    async getBranchVL (context, ids) {
      const response = await api.get(accountVL.branchVLItem(ids))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchVL', data: response.data })
        return response.data
      }
      return false
    },
    async deleteBranchVL (context, ids) {
      const response = await api.delete(accountVL.branchVLItem(ids))
      if (await requestValidation(response)) {
        context.commit('DELETE_BRANCH', ids.branchId)
        return response.data
      }
      return false
    },
    async updateBranchVL (context, data) {
      const response = await api.patch(accountVL.branchVL(data.id, data.branchId), { body: data.body })
      if (await requestValidation(response)) {
        await context.dispatch('getDirectoryById', { endpoint: 'city', id: response.data.address.city })
        context.commit('SET_DATA', { store, state: 'branchVL', data: response.data })
        return response.data
      }
      return false
    },

    async getBranchVLList (context, id) {
      const response = await api.get(accountVL.branchVL(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchesList', data: response.data.results })
        return response.data
      }
      return false
    },

    branchVLMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.post(accountVL.branchVLMedia(data.ids), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    branchVLUpdateMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.put(accountVL.branchVLUpdateMedia(data.ids), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    async branchVLDeleteMedia (context, data) {
      const response = await api.delete(accountVL.branchVLDeleteMedia(data))
      return !!(await requestValidation(response))
    },

    // Reprocessing VL
    async getMainQuestionVL (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewVL
      const response = await api.get(`${moderationQuestionVL.mainQuestion(id)}?answer=2&type_review=${typeReview}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationQuestionVL', data: response.data })
      }
    },
    async getFileQuestionVL (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewVL
      const response = await api.get(`${moderationQuestionVL.mainQuestionFile(id)}?answer=2&type_review=${typeReview}`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationFileQuestionVL', data: response.data })
      }
    },
    async getDirectorFileQuestionVL (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewVL
      const response = await api.get(`${moderationQuestionVL.directorFile(id)}?answer=2&type_review=${typeReview}`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationDirectorFileQuestionVL', data: response.data })
      }
    },

    async getBranchListVL (context, id) {
      const response = await api.get(`${moderationQuestionVL.branchList(id)}`)
      if (await requestValidation(response)) {
        let branchHasWrong = !!response.data.filter(e => e.has_rejected_reviews).length
        context.commit('SET_DATA', { store, state: 'hasModerationWrongBranch', data: branchHasWrong })
        response.data.forEach(item => {
          context.dispatch('getBranchQuestionVL', { id: id, branchId: item.id })
          context.dispatch('getBranchFileQuestionVL', { id: id, branchId: item.id })
        })
      }
    },
    async getBranchQuestionVL (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewVL
      const response = await api.get(`${moderationQuestionVL.branchItem({ id: data.id, branchId: data.branchId })}?answer=2&type_review=${typeReview}`)
      if (await requestValidation(response) && response.data.length) {
        let branchItem = {
          [data.branchId]: response.data.map(e => ({ field_name: e.check_list_question.field_name, comment: e.comment }))
        }
        context.commit('SET_BRANCH_QUERY', branchItem)
      }
    },

    async getBranchFileQuestionVL (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewVL
      const response = await api.get(`${moderationQuestionVL.branchFile({ id: data.id, branchId: data.branchId })}?answer=2&type_review=${typeReview}`)

      if (await requestValidation(response)) {
        let branchFile = {
          [data.branchId]: response.data.map(e => ({ field_name: e.file_type, comment: e.comment }))
        }
        context.commit('SET_BRANCH_FILE_QUESTION', branchFile)
      }
    }
  }
}
